import React, { useState, useContext, useEffect } from "react";
import SummaryView from "./SummaryView/SummaryView";
import DataView from "./DataView/DataView";
import { useRouteMatch, Route, useParams } from "react-router-dom";
import styled from "styled-components";
import { TitleText } from "../../ui/Text";
import { ToggleButton } from "../../ui/ToggleButton";
import { ScorecardIcon } from "../../assets/svg/ScorecardIcon";
import { CircleIcon } from "../../assets/svg/CircleIcon";
import { Button } from "../../ui/Button";
import { KPISubject } from "../../subjects/KPISubject";
import { get } from "../../utils/get";
import Modal from "../../ui/Modal";
import { UpdateMeasures } from "../dashboard/UpdateMeasures";
import { GetHook } from "../../api/api";
import { SCORECARD_URL } from "../../api/urls";
import moment from "moment";
import { BASE_API_URL } from "../../utils/app-constants";
import { AuthContext } from "../../context/AuthContext";
import { DateContext } from "../../context/DateFilterContext";

const KPIView = ({ scorecard,dateFilter, setDateFilter}: any) => {
  // const [dateFilter, setDateFilter] = useState("");
  const { path } = useRouteMatch();
  const params = useParams();
  const [isUpdateMeasuresModal, setUpdateMeasuresModal] = useState(false);
  const KPISub = KPISubject.value;
  const auth = useContext(AuthContext);
  const [dateFilterState, setDateFilterState] = useContext(DateContext)

  const { user } = get(auth, "authState");

  const date =
    get(dateFilterState, "startDate") && get(dateFilterState, "endDate")
      ? `interval=${moment(get(dateFilterState, "startDate")).format(
          "YYYY-MM-DD"
        )}/${moment(get(dateFilterState, "endDate")).format("YYYY-MM-DD")}`
      : "";

  const indicatorData = get(KPISub, "supporting_kpis", []).map((kpi) => {
    return {
      name: get(kpi, "kpi_name"),
      weight: get(kpi, "weight"),
      weighted_score: get(kpi, "weighted_periodic_score"),
    };
  });

  let { data: kpiData } = GetHook(
    date
      ? `${SCORECARD_URL}/${get(params, "scorecard_id")}/kpi?kpi_id=${get(
          params,
          "kpi_id"
        )}&${date}`
      : "null"
  );

  const { data: comments } = GetHook(
    get(kpiData, "[0]id")
      ? `${BASE_API_URL}/scorecardkpi/${get(
          kpiData,
          "[0]id"
        )}/comment`
      : "null"
  );

  useEffect(() => {
    KPISubject.next(kpiData);
  }, [kpiData]);

  const summaryData = {
    name: get(scorecard, "[0]display_name", "-"),
    target: get(scorecard, "[0]target"),
    weight: get(scorecard, "[0]weight"),
    maxScore: get(scorecard, "[0]max_score"),
    minScore: get(scorecard, "[0]min_score"),
    baseLine: get(scorecard, "[0]baseline"),
    score: get(scorecard, "[0]weighted_periodic_score"),
    optimization: get(scorecard, "[0]optimisation"),
    type: get(scorecard, "[0]perspective.perspective_type"),
    scoreType: get(scorecard, "[0]perspective.score_type"),
    operatingScore: get(scorecard, "[0]weighted_periodic_score"),
    comments: get(scorecard, "[0]comments", []),
    variance: get(scorecard, "[0]periodic_variance", []),
    status: get(scorecard, "[0]status", []),
  };

  const data = {
    name: get(kpiData, "[0]kpi_name", "-"),
    target: get(kpiData, "[0]target"),
    score: get(kpiData, "[0]periodic_score"),
    actual: get(kpiData, "[0]total_value"),
    weight: get(kpiData, "[0]weight"),
    maxScore: get(kpiData, "[0]max_score"),
    minScore: get(kpiData, "[0]min_score"),
    baseLine: get(kpiData, "[0]baseline"),
    optimization: get(kpiData, "[0]optimisation"),
    type: get(kpiData, "[0]kpi_target_type"),
    scoreType: get(kpiData, "[0]score_type"),
    operatingScore: get(kpiData, "[0]periodic_score"),
    weighted_score: get(kpiData, "[0]weighted_periodic_score"),
    variance: get(kpiData, "[0]periodic_variance"),
    comments: comments && comments,
    normalised_weight: get(kpiData, "[0]normalised_weight"),
  };

  return (
    <>
      <Container>
        <Header>
        <TitleText>
          <span style={{ fontSize: 14, color: "#214160", opacity: 0.5 , marginBottom: 10}}>
          {summaryData?.name}
          <CardLabel
          color={
            get(summaryData, "status", "") === "active" ? "#0eab64" :  "#222222"
          }
          backgroundColor={
            get(summaryData, "status", "") === "active" ? "#b7f7e6" :  "#c4c4c4"
          }
          style={{ marginLeft: 10 }} 
          disabled ={true}
          >
          <TitleText
          style={{ fontSize: 15 , paddingLeft: 12 , paddingRight: 12}} 
          
          >
          {summaryData?.status}
          </TitleText>
          </CardLabel>
          </span>
          KPI Overview
            
            </TitleText>

          <span>
            <ToggleButton
              url2="data"
              url1="summary"
              ButtonData2={{ label: "Data", icon: ScorecardIcon }}
              ButtonData1={{ label: "Summary", icon: CircleIcon }}
            />
            {get(scorecard, "[0]owner_id") === get(user, "id") ? (
              <Button
                text="Manage measures"
                onClick={() => setUpdateMeasuresModal(true)}
              />
            ) : null}
          </span>
        </Header>
        <>
          <Route
            path={`${path}summary`}
            render={() => (
              <SummaryView
              selectedScorecard={scorecard}
                title="KPI"
                data={data}
                indicatorTitle="Linked Indicators"
                indicatorData={indicatorData}
                dateFilter={dateFilterState}
                setDateFilter={setDateFilterState}
              />
            )}
          />
          <Route
            path={`${path}data`}
            render={() => (
              <DataView
                title="KPI"
                setDateFilter={setDateFilterState}
                data={kpiData}
              />
            )}
          />
        </>
      </Container>
      {isUpdateMeasuresModal && (
        <Modal
          width="90%"
          closeModal={() => setUpdateMeasuresModal(false)}
          title=""
          handleSubmit={() => null}
          noFooter
        >
          <TitleText> Manage measures  
          <span style={{ fontSize: 14, color: "#214160", opacity: 0.5}}>
          - {summaryData?.name}
          </span>
           </TitleText>
          <UpdateMeasures />
        </Modal>
      )}
    </>
  );
};

export default KPIView;

const Container = styled.div`
  display: grid;
  grid-template-rows: 5em auto;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 1px solid rgba(55, 81, 255, 0.1);
  padding: 3.3em 1em;
  span {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
`;

const CardLabel = styled.button<{
  backgroundColor: string;
  color: string;
}>`
border-radius: 0.5em;
display: grid;
align-items: center;
background-color: ${(props) => props.backgroundColor};
border-color: ${(props) => props.color};
${TitleText} {
  color: ${(props) => props.color};
  text-align: center;
  font-size: 12px;
  text-transform: capitalize;
}
`;
